@if (readonly() || disabled()) {
  <ng-container *ngTemplateOutlet="input" />
} @else {
  <cw-menu #autoCompleteMenu [maxWidth]="width()">
    <div slot="trigger">
      <ng-container *ngTemplateOutlet="input" />
    </div>

    @for (item of filteredData | async; track item) {
      <cw-menu-item [attr.data-vef]="attrVefItem()" [active]="item === control()?.value" (click)="selected(item)">{{
        item | printLabel: labelType()
      }}</cw-menu-item>
    }
  </cw-menu>
}

<ng-template #input>
  <cw-input
    customShadowCss
    [styles]="hideAssistiveOnNull() ? (error() ? assistiveBlock : assistiveNone) : ''"
    [attr.data-vef]="attrVef()"
    [class.disabled]="disabled()"
    [class.readonly]="readonly()"
    type="text"
    [status]="error() ? 'error' : null"
    [readonly]="readonly()"
    [disabled]="disabled()"
    [required]="required()"
    [placeholder]="placeholder()"
    (valueChange)="selected($event)"
    [value]="inputTextValue()"
    [label]="label()"
    [assistiveText]="error()"
  />
</ng-template>
